import moment from 'moment'
import 'moment/locale/de'
moment.locale('de')
export default moment
